function initVehicleFilter() {
  const makeSelect = document.querySelector("#vehicleMake:not([data-initialized])");
  const yearSelect = document.querySelector("#vehicleYear:not([data-initialized])");
  const engineSelect = document.querySelector("#vehicleEngine:not([data-initialized])");

  if (!makeSelect || !yearSelect || !engineSelect) return;

  // Mark them as initialized
  makeSelect.dataset.initialized = "true";
  yearSelect.dataset.initialized = "true";
  engineSelect.dataset.initialized = "true";

  let years = [];
  const availableFilters = {
    years: [],
    engines: []
  };

   const populateOptions = (selectEl, values, defaultLabel) => {
    // Clear existing options
    selectEl.innerHTML = "";
     console.log(selectEl.id);

    // Add default placeholder
    const placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.textContent = `${defaultLabel}`;
    selectEl.appendChild(placeholder);

     if(selectEl.id == "vehicleYear"){
    switch (makeSelect.value) {
      case "Nissan":
        console.log("Nissan");
        years = Array.from({ length: 2019 - 2016 + 1 }, (_, i) => 2016 + i);
        
        console.log(years);
        // Add new options
        years.forEach(value => {
          const opt = document.createElement("option");
          opt.value = value;
          opt.textContent = value;
          selectEl.appendChild(opt);
        });
        
        
        break;
      case "Ford":
        console.log("Ford");
        years = Array.from({ length: 2025 - 2001 + 1 }, (_, i) => 2001 + i);
        console.log(years);
        // Add new options
        years.forEach(value => {
          const opt = document.createElement("option");
          opt.value = value;
          opt.textContent = value;
          selectEl.appendChild(opt);
        });
        break;
      case "Dodge Ram":
        console.log("Dodge Ram");
        years = Array.from({ length: 2024 - 2001 + 1 }, (_, i) => 2001 + i);
        console.log(years);
        // Add new options
        years.forEach(value => {
          const opt = document.createElement("option");
          opt.value = value;
          opt.textContent = value;
          selectEl.appendChild(opt);
        });
        break;
      case "GM/Chevy":
        console.log("GM/Chevy");
        years = Array.from({ length: 2023 - 2001 + 1 }, (_, i) => 2001 + i);
        console.log(years);
        // Add new options
        years.forEach(value => {
          const opt = document.createElement("option");
          opt.value = value;
          opt.textContent = value;
          selectEl.appendChild(opt);
        });
        break;
      case "jeep":
        console.log("Jeep");
        years = Array.from({ length: 2023 - 2014 + 1 }, (_, i) => 2014 + i);
        console.log(years);
        // Add new options
        years.forEach(value => {
          const opt = document.createElement("option");
          opt.value = value;
          opt.textContent = value;
          selectEl.appendChild(opt);
        });
        break;
      default:
    }
     }
  };

  makeSelect.addEventListener("change", async function () {
    const handle = this.selectedOptions?.[0]?.dataset?.handle;
    if (!handle) return;

    console.log("handle", handle);

    populateOptions(yearSelect, [], "Vehicle Year");
    populateOptions(engineSelect, [], "Engine Type");

    try {
      const res = await fetch(`/collections/${handle}?sections=collection-filters`);
      const data = await res.json();
      const html = data["collection-filters"];

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const checkboxes = doc.querySelectorAll('input[type="checkbox"]');

      availableFilters.years = Array.from(checkboxes)
        .filter(cb => cb.name === "filter.p.m.custom.year")
        .map(cb => cb.value);

      console.log("✅ Available years:", availableFilters.years);
      populateOptions(yearSelect, availableFilters.years, "Vehicle Year");
    } catch (err) {
      console.error("Error loading years:", err);
    }
  });

  yearSelect.addEventListener("change", function () {
    const year = this.value;
    const make = makeSelect.value;
    const handle = makeSelect.selectedOptions?.[0]?.dataset?.handle;
    if (!year || !handle || !make) return;

    engineSelect.innerHTML = `<option value="">Engine Type</option>`;
    const queryParams = new URLSearchParams({
      sections: "collection-filters",
      "filter.p.m.custom.year": year,
      "filter.p.m.custom.make": make,
    });

    fetch(`/collections/${handle}?${queryParams.toString()}`)
      .then(res => res.json())
      .then(data => {
        const html = data["collection-filters"];
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const checkboxes = doc.querySelectorAll('input[type="checkbox"]');

        const engines = Array.from(checkboxes)
          .filter(cb => {
            return (
              cb.name === "filter.p.m.custom.engine" &&
              /\(\d+\)/.test(cb.nextSibling?.textContent) &&
              !/\(0\)/.test(cb.nextSibling?.textContent)
            );
          })
          .map(cb => cb.value);

        console.log("✅ Engine options:", engines);


      var selectedYear = "";
      var optionsToAppend = [];
      switch (makeSelect.value) {
        case "Nissan":
          console.log("Nissan");          
          ["5.0L"].forEach(value => {
            const option = document.createElement("option");
            option.value = engines;
            option.textContent = value;
            engineSelect.appendChild(option);
          });
        break;
        case "Ford":
          console.log("Ford");
          selectedYear = parseInt(yearSelect.value);          
          optionsToAppend = [];
          if(selectedYear == 2001 || selectedYear == 2002){
            optionsToAppend.push("All Engines");
          }
          if(selectedYear == 2003 || selectedYear == 2004 || selectedYear == 2005 || selectedYear == 2006 || selectedYear == 2007){
            optionsToAppend.push("6.0L");
          }
          if(selectedYear == 2008 || selectedYear == 2009 || selectedYear == 2010){
            optionsToAppend.push("6.4L");
          }
          if(selectedYear == 2011 || selectedYear == 2012 || selectedYear == 2013 ||selectedYear == 2014 || selectedYear == 2015 || selectedYear == 2016 || selectedYear == 2017 || selectedYear == 2018 || selectedYear == 2019
             || selectedYear == 2020 || selectedYear == 2021 || selectedYear == 2022 || selectedYear == 2023 || selectedYear == 2024 || selectedYear == 2025){
            optionsToAppend.push("6.7L");
          }
          optionsToAppend.forEach(value => {
            const opt = document.createElement('option');
            opt.textContent = value;
            if(value == "6.0L"){
              opt.value = "6.0L Powerstroke";
            }else if(value == "6.4L"){
              opt.value = "6.4L Powerstroke";
            }else if(value == "6.7L"){
              opt.value = "6.7L Powerstroke";
            }else{
              opt.value = value;
            }
            
            engineSelect.appendChild(opt);
          });
          
          /*engines.forEach(value => {
            const option = document.createElement("option");
            option.value = value;
            option.textContent = value;
            engineSelect.appendChild(option);
          });*/
        break;
        case "Dodge Ram":
          console.log("Dodge Ram");
          selectedYear = parseInt(yearSelect.value);          
          optionsToAppend = [];
          if(selectedYear == 2001 || selectedYear == 2002 || selectedYear == 2003 || selectedYear == 2004){
            optionsToAppend.push("All Engines");
          }
          if(selectedYear == 2005 || selectedYear == 2006 || selectedYear == 2007){
            optionsToAppend.push("5.9L");
          }
          if(selectedYear == 2007 || selectedYear == 2008 || selectedYear == 2009 || selectedYear == 2010 || selectedYear == 2011 || selectedYear == 2012 || selectedYear == 2013 || selectedYear == 2014 || selectedYear == 2015 || selectedYear == 2016
             || selectedYear == 2016 || selectedYear == 2017 || selectedYear == 2018 || selectedYear == 2019 || selectedYear == 2020 || selectedYear == 2021 || selectedYear == 2022 || selectedYear == 2023 || selectedYear == 2024){
            optionsToAppend.push("6.7L");
          }
          if(selectedYear == 2014 || selectedYear == 2015 || selectedYear == 2016 || selectedYear == 2017 || selectedYear == 2018 || selectedYear == 2019 || selectedYear == 2020 || selectedYear == 2021 || selectedYear == 2022 || selectedYear == 2023){
            optionsToAppend.push("3.0L");
          }
          optionsToAppend.forEach(value => {
            const opt = document.createElement('option');
            opt.textContent = value;
            if(value == "5.9L"){
              opt.value = "5.9L Cummins";
            }else if(value == "6.7L"){
              opt.value = "Cummins 6.7L";
            }else if(value == "3.0L"){
              opt.value = "EcoDiesel 3.0L";
            }else{
              opt.value = value;
            }
            
            engineSelect.appendChild(opt);
          });
          
          /*engines.forEach(value => {
            const option = document.createElement("option");
            option.value = value;
            option.textContent = value;
            engineSelect.appendChild(option);
          });*/
        break;
        case "GM/Chevy":
          console.log("GM/Chevy");
          selectedYear = parseInt(yearSelect.value);          
          optionsToAppend = [];
          if(selectedYear == 2001 || selectedYear == 2002 || selectedYear == 2003 || selectedYear == 2004 || selectedYear == 2006 || selectedYear == 2007){
            optionsToAppend.push("6.6L LB7 Duramax");
          }
          if(selectedYear == 2004 || selectedYear == 2005 || selectedYear == 2007){
            optionsToAppend.push("6.6L LLY Duramax");
          }
          if(selectedYear == 2006){
            optionsToAppend.push("6.6L LBZ Duramax");      
          }
          if(selectedYear == 2008 || selectedYear == 2009 || selectedYear == 2010){
            optionsToAppend.push("6.6L LMM Duramax");      
          }
          if(selectedYear == 2011 || selectedYear == 2012 || selectedYear == 2013 || selectedYear == 2014 || selectedYear == 2015 || selectedYear == 2016){
            optionsToAppend.push("6.6L LML Duramax");      
          }
          if(selectedYear == 2016 || selectedYear == 2017 || selectedYear == 2018 || selectedYear == 2019 || selectedYear == 2020 || selectedYear == 2021 || selectedYear == 2022){
            optionsToAppend.push("2.8L Duramax");      
          }
          if(selectedYear == 2017 || selectedYear == 2018 || selectedYear == 2019 || selectedYear == 2020 || selectedYear == 2021 || selectedYear == 2022 || selectedYear == 2023){
            optionsToAppend.push("L5P");      
          }
          if(selectedYear == 2020 || selectedYear == 2021 || selectedYear == 2022){
            optionsToAppend.push("LM2");      
          }
            optionsToAppend.forEach(value => {
              const opt = document.createElement('option');
              opt.textContent = value;
              opt.value = value;
              engineSelect.appendChild(opt);
            });
        break;
        case "jeep":
          console.log("Jeep");
          console.log(engines);
          ["3.0L"].forEach(value => {
            const option = document.createElement("option");
            option.value = engines;
            option.textContent = value;
            engineSelect.appendChild(option);
          });
        break;
        default:
      }

      }).catch(err => {
        console.error("Error loading engines:", err);
        engineSelect.innerHTML = `<option value="">Error loading engines</option>`;
      });
  });

  ['vehicleMake', 'vehicleYear', 'vehicleEngine'].forEach(id => {
    const select = document.getElementById(id);
    if (!select.dataset.listenerAdded) {
      select.addEventListener('change', function () {
        if (this.value) this.classList.remove('input-error');
      });
      select.dataset.listenerAdded = "true";
    }
  });

document.addEventListener('click', function (e) {
  if (e.target && e.target.id === 'submitFilter') {
    e.preventDefault();

    const section = e.target.closest('.filter-info');
    if (!section) return;

    const baseUrl = 'https://thedieseldudes.com/collections/all-diesel-products';
    const selects = [
      section.querySelector('#vehicleMake'),
      section.querySelector('#vehicleYear'),
      section.querySelector('#vehicleEngine')
    ];

    const params = [];
    let allValid = true;

    selects.forEach(select => {
      const tagName = select.getAttribute('data-tag');
      const value = select?.value;

      if (!value) {
        allValid = false;
        select?.classList.add("input-error");
      } else {
        select.classList.remove("input-error");
        if (select.id === "vehicleEngine" && value.includes(',')) {
          value.split(',').forEach(v => params.push(`${tagName}=${encodeURIComponent(v.trim())}`));
        } else if (value.includes('All Engines')) {
          // skip
        } else {
          params.push(`${tagName}=${encodeURIComponent(value)}`);
        }
      }
    });

    if (!allValid) return;

    const url = `${baseUrl}?${params.join('&')}`;
    console.log("Navigating to:", url);
    window.location.href = url;
  }
});

  
if (!yearSelect.dataset.focusListener) {
  yearSelect.addEventListener("focus", function () {
    if (!makeSelect.value) {
      showValidationMessage("Choose Make First");
    }
  });
  yearSelect.dataset.focusListener = "true";
}

if (!engineSelect.dataset.focusListener) {
  engineSelect.addEventListener("focus", function () {
    const makeSelected = !!makeSelect.value;
    const yearSelected = !!yearSelect.value;

    if (!makeSelected && !yearSelected) {
      showValidationMessage("Choose Make/Year First");
    } else if (makeSelected && !yearSelected) {
      showValidationMessage("Choose Year First");
    }
  });
  engineSelect.dataset.focusListener = "true";
}
  
}

function showValidationMessage(text) {
  const msg = document.getElementById("validationMessage");
  if (!msg) return;

  msg.textContent = text;
  msg.style.display = "block";

  setTimeout(() => {
    msg.style.display = "none";
  }, 3000);
}


document.addEventListener("DOMContentLoaded", () => {
  const tryInit = () => {
    // Retry initialization after a small delay if elements are missing
    setTimeout(() => {
      initVehicleFilter();
    }, 50);
  };

  tryInit(); // Try once immediately

  // Also observe for dynamic inserts from Shopify
  const observer = new MutationObserver(() => {
    tryInit(); // Retry again when changes happen
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

